import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../../services/general.service';
import { AuthenticationService } from '../../../core/services/authentication.service';

@Component({
  selector: 'app-mobile',
  templateUrl: './mobile.component.html',
  styleUrls: ['./mobile.component.scss']
})
export class MobileComponent implements OnInit {
  customerServiceNumber: string;

  constructor(private generalService: GeneralService,
    private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.customerServiceNumber = this.generalService.getCustomerSupportNumber();
  }

  getMobileOperatingSystem() {
    const userAgent = navigator.userAgent || navigator.vendor;

        // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
          return 'Windows Phone';
      }

      if (/android/i.test(userAgent)) {
          return 'Android';
      }

      if (/iPad|iPhone|iPod/.test(userAgent)) {
          return 'iOS';
      }

      return 'unknown';
  }


  getRespectiveDownloadBtn() {
    if (this.getMobileOperatingSystem() === 'iOS') {
      return './assets/img/icons/apple-store-badge.png';
    } else {
      return './assets/img/icons/google-play-badge.png';
    }
  }

  openUrl() {
    if (this.getMobileOperatingSystem() === 'iOS') {
      window.location.href = this.generalService.translate.instant('itunesLink');
    } else {
      window.location.href = this.generalService.translate.instant('googleLink');
    }
    this.authenticationService.logout();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/mobile/mobile.component.ts